export const toPascalCase = (value: string) =>
    value
        .replace(/[-_ ]+/g, ' ')
        .split(' ')
        .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join('');

export const toTitleCase = (value: string) =>
    value
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' ')
        .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');

export function splitArray<T>(array: T[], chunkSize: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
}
export function formatCurrency(value: number | string): string {
    return new Intl.NumberFormat('vi-VN').format(+value);
}

export function convertToVietNamesePhone(phoneNumber: string = ''): string {
    const phoneLength = 11;
    const countryCode = '84';
    const digitsOnly = phoneNumber?.replace(/\D/g, '');

    if (digitsOnly?.length === phoneLength) {
        if (digitsOnly.startsWith(countryCode)) {
            return '0' + digitsOnly.slice(2);
        } else if (!digitsOnly.startsWith('0')) {
            return digitsOnly;
        }
    }
    return phoneNumber;
}
export function log(titleError: string, error?: any) {
        console.log(`%c ${titleError} `, 'background:black; color: red', error);
    }

